export const EMAIL = "email";
export const PASSWORD = "password";
export const PERSONAL_ACCOUNT = "INDIVIDUAL";
export const MERCHANT_ACCOUNT = "BUSINESS";
export const USER_NAME = "name";
export const FIRST_NAME = "given_name";
export const LAST_NAME = "family_name";
export const PHONE = "phone";
export const TERMS_CONDITIONS_PRIVACY = "terms";
